import React from 'react';
import { PropTypes } from "prop-types";

const ModalInput2 = ({
    type,
    label,
    field,
    form,
    onChange,
    onBlur,
    name,
    onFocus,
    placeholder
}) => {
    return (
        <div>
            <div className="modal-input-container">
                <label className="modal-input-label">{label}</label>
                <input
                    type={type}
                    placeholder={placeholder}
                    onFocus={onFocus}
                    onChange={(field && field.onChange) || onChange}
                    onBlur={(field && field.onBlur) || onBlur}
                    value={(field && field.value) || ''}
                    name={(field && field.name) || name}
                    className="modal-input-input"
                    readOnly
                />
            </div>
            {form && form.touched[field.name] && form && form.errors[field.name] && (
                <small className="modal-errors">{form.errors[field.name]}</small>
            )}
        </div>
    )
}

ModalInput2.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    field: PropTypes.object,
    form: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string,
    onFocus: PropTypes.func,
    label: PropTypes.string,
    subLabel: PropTypes.string
  }

export default ModalInput2;
